import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const WS_BASE = API.replace(/^https/, "wss").replace(/^http/, "ws");

export const apiClient = axios.create({ baseURL: API, withCredentials: true });

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("pv_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

let refreshPromise = null;

function refreshAccessToken() {
  if (!refreshPromise) {
    refreshPromise = axios
      .post(`${API}/auth/refresh`, {}, { withCredentials: true })
      .then(({ data }) => {
        localStorage.setItem("pv_token", data.access_token);
        return data.access_token;
      })
      .finally(() => {
        refreshPromise = null;
      });
  }
  return refreshPromise;
}

apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const { config, response } = error;
    const skipRefresh = ["/auth/login", "/auth/register", "/auth/refresh", "/auth/logout"].some((p) => config?.url?.startsWith(p));
    if (response?.status === 401 && !skipRefresh && !config._retried) {
      config._retried = true;
      try {
        const newToken = await refreshAccessToken();
        config.headers.Authorization = `Bearer ${newToken}`;
        return apiClient(config);
      } catch {
        localStorage.removeItem("pv_token");
        if (window.location.pathname.startsWith("/dashboard") || window.location.pathname.startsWith("/present")) {
          window.location.href = "/login";
        }
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function apiErrorMessage(e) {
  return formatApiError(e?.response?.data?.detail) || e?.message || "Something went wrong";
}
